import { useMemo } from "react"

import type { MatchRecap } from "@/types"

import { computeBeatState } from "./beat-calculator"
import { KeyPlayBeat } from "./key-play-beat"
import { ScrollCaptureContainer } from "./scroll-capture-container"

interface KeyPlaysStorytellingProps {
  recap: MatchRecap
  homeTeamId: string
  homeTeamHue: number
  awayTeamHue: number
}

export function KeyPlaysStorytelling({
  recap,
  homeTeamId,
  homeTeamHue,
  awayTeamHue,
}: KeyPlaysStorytellingProps) {
  const commentaryCounts = useMemo(
    () => recap.key_plays.map((p) => p.commentary.length),
    [recap.key_plays],
  )

  const totalPlays = recap.key_plays.length

  if (totalPlays === 0) return null

  return (
    <div
      className="relative"
      style={{
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
      }}
    >
      <ScrollCaptureContainer commentaryCounts={commentaryCounts}>
        {(progress) => (
          <div className="relative h-full w-full">
            {recap.key_plays.map((play, idx) => {
              const beatState = computeBeatState(
                progress,
                idx,
                commentaryCounts,
              )
              return (
                <KeyPlayBeat
                  key={idx}
                  play={play}
                  playIndex={idx}
                  beatState={beatState}
                  recap={recap}
                  homeTeamId={homeTeamId}
                  homeTeamHue={homeTeamHue}
                  awayTeamHue={awayTeamHue}
                />
              )
            })}
          </div>
        )}
      </ScrollCaptureContainer>
    </div>
  )
}
